import React from 'react';
const stats = [{
  value: '200+',
  label: 'Coaches'
}, {
  value: '14 + 6',
  label: 'Box set & bonuses'
}, {
  value: '4.9/5',
  label: 'Average rating'
}, {
  value: 'Worldwide',
  label: 'Trusted globally'
}];
export function StatsBar() {
  return <section className="bg-ink px-5 pt-10 pb-12 md:pt-0 md:pb-14" data-id="element-223" data-mp="1jctw9o1hfxtc">
      <div className="max-w-6xl mx-auto bg-panel border border-acid/15 grid grid-cols-2 lg:grid-cols-4 divide-y divide-x divide-white/10 lg:divide-y-0" data-id="element-224" data-mp="1jeoj57wbe002">
        {stats.map(stat => <div key={stat.label} className="py-6 md:py-8 px-3 text-center" data-id="element-225" data-mp="19l7m7v0vs4s6">
            <div className="font-display uppercase text-acid text-2xl md:text-4xl mb-1" data-id="element-226" data-mp="15lp5zck08hvo">
              {stat.value}
            </div>
            <div className="text-[0.6rem] md:text-xs uppercase tracking-[0.12em] text-gray-400 font-medium" data-id="element-227" data-mp="10jzrfmxkpm2u">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}